module.exports = __webpack_public_path__ + "img/ic24Comb.b1226cc8.svg";